import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  TimeToDatePipe,
  CutTextPipe,
  SafeUrlPipe,
  FacultyTransPipe,
  IdToFbPP,
  KeyValuePipe,
  OrderByPipe,
  TransformUrlToHrefPipe,
} from "../pipes";

// FortAwesome
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faLock,
  faBriefcase,
  faList,
  faTachometerAlt,
  faEye,
  faFileAlt,
  faFlag,
  faCircle,
  faStar,
  faComment,
  faVideo,
  faArrowAltCircleLeft,
  faTrash,
  faCheck,
  faCheckCircle,
  faFolderOpen,
  faUpload,
  faPlus,
  faCamera,
  faCaretUp,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faGlobe,
  faTable,
  faSignOutAlt,
  faListAlt,
  faThLarge,
  faAddressBook,
  faComments,
  faDownload,
  faSearch,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faBan,
  faPlay,
  faPlayCircle,
  faCalendar,
  faArchive,
  faTimes,
  faMonument,
  faLandmark,
  faCopy,
  faQuestionCircle,
  faTimesCircle,
  faQuestion,
  faTags,
  faChevronLeft,
  faChevronRight,
  faLink,
  faPencilAlt,
  faEdit,
  faCompress,
  faExpandArrowsAlt,
  faSearchMinus,
  faSearchPlus,
  faFileDownload,
  faInfoCircle,
  faCommentAlt,
  faEnvelope,
  faWindowMaximize,
  faChartPie,
  faHome
} from "@fortawesome/free-solid-svg-icons";
import { DpDatePickerModule } from "ng2-date-picker";
import { AppResetPwdComponent } from "app/views/profile/component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Add font awesome icons
library.add(faUser);
library.add(faLock);
library.add(faBriefcase);
library.add(faList);
library.add(faTachometerAlt);
library.add(faEye);
library.add(faFileAlt);
library.add(faFlag);
library.add(faCircle);
library.add(faStar);
library.add(faComment);
library.add(faVideo);
library.add(faArrowAltCircleLeft);
library.add(faTrash);
library.add(faCheck);
library.add(faCheckCircle);
library.add(faFolderOpen);
library.add(faUpload);
library.add(faPlus);
library.add(faCamera);
library.add(faCaretUp);
library.add(faCaretDown);
library.add(faCaretLeft);
library.add(faCaretRight);
library.add(faGlobe);
library.add(faTable);
library.add(faSignOutAlt);
library.add(faListAlt);
library.add(faThLarge);
library.add(faAddressBook);
library.add(faComments);
library.add(faDownload);
library.add(faSearch);
library.add(faAngleLeft);
library.add(faAngleDoubleLeft);
library.add(faAngleRight);
library.add(faAngleDoubleRight);
library.add(faBan);
library.add(faPlay);
library.add(faPlayCircle);
library.add(faCalendar);
library.add(faArchive);
library.add(faTimes);
library.add(faMonument);
library.add(faLandmark);
library.add(faCopy);
library.add(faQuestionCircle);
library.add(faQuestion);
library.add(faTimesCircle);
library.add(faTimes);
library.add(faTags);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faLink);
library.add(faPencilAlt);
library.add(faEye);
library.add(faEdit);
library.add(faCompress);
library.add(faExpandArrowsAlt);
library.add(faSearchMinus);
library.add(faSearchPlus);
library.add(faFileDownload);
library.add(faInfoCircle);
library.add(faCommentAlt);
library.add(faEnvelope);
library.add(faWindowMaximize);
library.add(faChartPie);
library.add(faHome);
const PIPES = [
  TimeToDatePipe,
  CutTextPipe,
  SafeUrlPipe,
  FacultyTransPipe,
  IdToFbPP,
  KeyValuePipe,
  OrderByPipe,
  TransformUrlToHrefPipe,
];

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    DpDatePickerModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [...PIPES, AppResetPwdComponent],
  exports: [...PIPES, FontAwesomeModule, AppResetPwdComponent],
})
export class SharedModule { }
